import { DateCell } from '../TableCells/DateCell';
import { FixCell } from '../TableCells/FixCell';
import { ValueCell } from '../TableCells/ValueCell';

export const activeProblemsTableColumns = [
  {
    Header: 'Name',
    accessor: 'name',
    width: 30,
    Cell: ValueCell,
  },
  {
    Header: 'Entity Type',
    accessor: 'entity',
    width: 20,
  },
  {
    Header: 'QBO ID',
    accessor: 'assumedMappingId',
    width: 30,
    Cell: ValueCell,
  },
  {
    Header: 'Detected Date',
    accessor: 'detectedAt',
    width: 15,
    Cell: DateCell,
  },
  {
    Header: '',
    accessor: 'control',
    width: 5,
    Cell: FixCell,
  },
];

export const entityOptions = [
  { label: 'Billing Instance', value: 'BillingInstance' },
  { label: 'QuickBooks Class', value: 'QuickBooksClass' },
  { label: 'Management', value: 'Management' },
  { label: 'Community', value: 'Community' },
  { label: 'Attorney', value: 'Attorney' },
];
